import React, { useState } from 'react'
import { CButton, CFormInput, CFormLabel, CFormSelect } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { icon } from '../../../shared/icons'
import { useBostonState, emit } from '../lib/useBoston'
import { ensureGateway } from '../lib/gateway'
import { useUI } from '../../../shared/ui/UIProvider'

/* Port fiel de viewRemarks/bindRemarks + loadRemarks/addRemark/deleteRemark de boston_ia:
   CRUD de remarks — GET via backend Boston, ADD ejecuta el comando 5 directo en Sabre Web. */
function RemarksView() {
  const state = useBostonState()
  const { toast } = useUI()
  const [pnr, setPnr] = useState(state.remarksPnr || '')
  const [type, setType] = useState('General')
  const [mask, setMask] = useState('')
  const [seg, setSeg] = useState('')
  const [txt, setTxt] = useState('')

  /* Headers originales de las APIs Sabre del backend Boston (x-api-key + token de sesion). */
  function sabreHeaders() {
    return {
      'Content-Type': 'application/json',
      'x-api-key': state.config.bostonAkey,
      ...(state.sessionToken ? { token: state.sessionToken } : {}),
    }
  }

  async function loadRemarks() {
    if (!state.remarksPnr) return
    state.remarksLoading = true
    emit()
    try {
      const params = new URLSearchParams({ pnr: state.remarksPnr, includeExpired: 'true', limit: '100' })
      const url = state.config.bostonApi.replace(/\/$/, '') + '/sabre/remarks?' + params
      const resp = await fetch(url, { headers: sabreHeaders() })
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
      state.remarksList = await resp.json()
    } catch (e) {
      toast(`Error cargando remarks: ${e.message}`, 'danger')
      state.remarksList = []
    } finally {
      state.remarksLoading = false
      emit()
    }
  }

  async function addRemark() {
    const text = txt.trim()
    const remarkType = type || 'General'
    const maskVal = mask.trim()
    const segment = seg ? Number(seg) : undefined
    if (!state.remarksPnr || !text) return
    try {
      const valor = maskVal ? maskVal + text : text
      const cmd = segment ? `5/S${segment}/${valor}` : `5${valor}`
      const exec = await ensureGateway().executeCommand(cmd)
      if (!exec.success) throw new Error(exec.responseText)
      const url = state.config.bostonApi.replace(/\/$/, '') + '/sabre/addremarks'
      await fetch(url, {
        method: 'POST',
        headers: sabreHeaders(),
        body: JSON.stringify({ pnr: state.remarksPnr, text: valor, type: remarkType, segment }),
      })
      await loadRemarks()
    } catch (e) {
      toast(`Error: ${e.message}`, 'danger')
    }
  }

  async function deleteRemark(remarkId) {
    try {
      const url = state.config.bostonApi.replace(/\/$/, '') + '/sabre/deleteremarks'
      await fetch(url, {
        method: 'POST',
        headers: sabreHeaders(),
        body: JSON.stringify({ pnr: state.remarksPnr, remarkId }),
      })
      await loadRemarks()
    } catch (e) {
      toast(`Error: ${e.message}`, 'danger')
    }
  }

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Remarks</h1>
          <p>
            CRUD de remarks: GET via backend Boston, ADD ejecuta el comando <code>5</code> directo en Sabre Web.
          </p>
        </div>
      </div>

      <div className="card-x" style={{ padding: 16 }}>
        <h3>PNR</h3>
        <div className="bia-row-input">
          <CFormInput
            className="bia-mono"
            maxLength={6}
            placeholder="ABC123"
            value={pnr}
            onChange={(event) => {
              const value = event.target.value.trim().toUpperCase()
              setPnr(value)
              state.remarksPnr = value
            }}
          />
          <CButton color="success" className="btn-brand" onClick={loadRemarks}>
            <CIcon icon={icon('cilSearch')} /> Cargar
          </CButton>
        </div>
      </div>

      <div className="card-x" style={{ padding: 16 }}>
        <h3>Agregar remark</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 12 }}>
          <div>
            <CFormLabel>Tipo de remark</CFormLabel>
            <CFormSelect value={type} onChange={(event) => setType(event.target.value)}>
              <option value="General">General</option>
              <option value="Invoice">Invoice</option>
              <option value="Itinerary">Itinerary</option>
              <option value="Historical">Historical</option>
              <option value="Ticket">Ticket</option>
            </CFormSelect>
          </div>
          <div>
            <CFormLabel>Máscara (prefijo)</CFormLabel>
            <CFormInput
              className="bia-mono"
              placeholder="H- · CC- · 5H-"
              value={mask}
              onChange={(event) => setMask(event.target.value)}
            />
          </div>
          <div>
            <CFormLabel>Segmento (opcional)</CFormLabel>
            <CFormInput
              type="number"
              min={1}
              max={9}
              value={seg}
              onChange={(event) => setSeg(event.target.value)}
            />
          </div>
        </div>
        <div style={{ marginBottom: 12 }}>
          <CFormLabel>Texto</CFormLabel>
          <CFormInput placeholder="Texto del remark" value={txt} onChange={(event) => setTxt(event.target.value)} />
        </div>
        <CButton color="success" className="btn-brand" onClick={addRemark}>
          <CIcon icon={icon('cilPlus')} /> Agregar
        </CButton>
      </div>

      <div className="card-x" style={{ padding: 16 }}>
        <div className="bia-card-head">
          <h3>Remarks del PNR</h3>
          <span className="bia-pill">{state.remarksList.length}</span>
        </div>
        {state.remarksLoading ? (
          <p className="bia-empty">Cargando...</p>
        ) : !state.remarksPnr ? (
          <p className="bia-empty">Carga un PNR primero.</p>
        ) : !state.remarksList.length ? (
          <p className="bia-empty">No hay remarks en este PNR.</p>
        ) : (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
              gap: 12,
              marginTop: 8,
              alignItems: 'start',
            }}
          >
            {state.remarksList.map((r, i) => (
              <div className="card-x" style={{ padding: 12, marginBottom: 0 }} key={r.id || i}>
                <div className="bia-card-head">
                  <strong>{r.type || 'GENERAL'}</strong>
                  <CButton size="sm" color="danger" variant="ghost" onClick={() => deleteRemark(r.id)} title="Borrar remark">
                    <CIcon icon={icon('cilX')} />
                  </CButton>
                </div>
                <p style={{ margin: '6px 0' }}>{r.text}</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, fontSize: 12, color: 'var(--muted)' }}>
                  <span>{r.id}</span>
                  {r.segment ? <span>· Seg {r.segment}</span> : null}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  )
}

export default RemarksView
